import React from "react";
// Component
import MainTable from "../../Components/Tables/Main/MainTable";
// Hook
import { useVehicleIncidences } from "../../Hooks/useVehicleIncidences";
import { useVehicles } from "../../Hooks/useVehicles";
// Library
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useParams } from "react-router-dom";
// Constants
import { requirementTypes, resolveTimezoneOffsetError } from "../../CommonConstants";

const VehicleDocuments = () => {
  let { vehicleId } = useParams();
  vehicleId = +vehicleId;
  const [
    vehiclesIncidencesData,
    addVehicleIncidence,
    updateIncidence,
    deleteIncidence
  ] = useVehicleIncidences(vehicleId);
  const [vehiclesData] = useVehicles();

  const vehicle = vehiclesData.find(({ id }) => id === vehicleId);
  let vehicleName = "";
  if (vehicle) {
    const { brand, model, patent } = vehicle;
    vehicleName = `${brand} ${model} ${patent}`;
  }

  const columns = [
    { title: "Id", field: "id", hidden: true },
    { title: "Descripción", field: "description" },
    { title: "Tipo", field: "type", lookup: { infraction: "Infracción", ...requirementTypes} },
    { title: "Kilómetros", field: "kilometers" },
    { title: "Costo", field: "cost" },
    { title: "Número de factura", field: "invoiceNumber" },
    {
      title: "Fecha",
      field: "actionDate",
      type: "date",
      render: row => row.actionDate ? <span>{resolveTimezoneOffsetError(row.actionDate, 'dd/MM/yyyy')}</span> : <span></span>,
      editComponent: props => (
        <MuiPickersUtilsProvider utils={DateFnsUtils}
          locale={props.dateTimePickerLocalization}>
          <DatePicker
            format="dd/MM/yyyy"
            value={props.value ? resolveTimezoneOffsetError(props.value) : null}
            onChange={props.onChange}
            clearable
            InputProps={{
              style: {
                fontSize: 13,
              }
            }}
          />
        </MuiPickersUtilsProvider>
      )
    }
  ];

  return (
    <MainTable
      title={`Incidencias de ${vehicleName}`}
      columns={columns}
      data={vehiclesIncidencesData}
      requiredFields={["description", "actionDate", "type"]}
      deleteText="Se borraran todos los requerimientos asociados"
      onRowAdd={async (newData) => {
        await addVehicleIncidence({
          ...newData,
          actionDate: resolveTimezoneOffsetError(newData.actionDate, "yyyy-MM-dd"),
          vehicleId,
        });
      }}
      onRowUpdate={async (newData) => {
        const dataToSave = { ...newData }
        delete dataToSave.id
        delete dataToSave.vehicleId
        dataToSave.actionDate = dataToSave.actionDate ? resolveTimezoneOffsetError(dataToSave.actionDate, "yyyy-MM-dd") : null
        await updateIncidence(dataToSave, newData.id)
      }}
      onRowDelete={deleteIncidence}
    />
  );
};

export default VehicleDocuments;



// WEBPACK FOOTER //
// ./src/Containers/VehicleIncidences/index.js